/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取三方订单快递运费
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  getExpressFeeReq: order.GetExpressFeeDMReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: number;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/express-fee`,
    data: getExpressFeeReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
